var _path, _rect, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8096 13.5898C28.1208 13.5898 13.7813 27.9294 13.7812 45.6182C13.7812 63.307 28.1208 77.6465 45.8096 77.6465C46.1409 77.6464 46.4591 77.5146 46.6934 77.2803L51.9229 72.0508H56.4795L64.1416 79.7129V87.5889C64.1416 88.2792 64.7013 88.8389 65.3916 88.8389H75.334V98.7812C75.334 99.4716 75.8936 100.031 76.584 100.031H86.5254V109.974C86.5255 110.664 87.0853 111.223 87.7754 111.224H110.16C110.85 111.224 111.41 110.664 111.41 109.974V93.1855C111.41 92.8542 111.278 92.5361 111.044 92.3018L72.2422 53.5V51.7314L77.4717 46.502C77.7059 46.2676 77.8379 45.9496 77.8379 45.6182C77.8378 27.9296 63.4981 13.5901 45.8096 13.5898ZM45.8096 16.0898C61.9465 16.0901 75.0588 29.0347 75.332 45.1064L70.1084 50.3301C69.8741 50.5644 69.7423 50.8825 69.7422 51.2139V53.9121C69.7139 54.2646 69.834 54.6268 70.1035 54.8965L108.91 93.7031V108.724H89.0254V98.7812C89.0254 98.091 88.4657 97.5313 87.7754 97.5312H77.834V87.5889C77.8338 86.8988 77.2741 86.3391 76.584 86.3389H66.6416V79.1953C66.6416 78.8639 66.5097 78.5459 66.2754 78.3115L57.9307 69.9658C57.7268 69.7392 57.4418 69.5872 57.1211 69.5566C57.0974 69.5543 57.0736 69.5537 57.0498 69.5527C57.0339 69.5521 57.018 69.5508 57.002 69.5508H51.4053L51.2822 69.5566C50.9961 69.585 50.7266 69.712 50.5215 69.917L45.2988 75.1396C29.2263 74.8671 16.2812 61.7557 16.2812 45.6182C16.2813 29.3102 29.5015 16.0898 45.8096 16.0898Z",
    fill: "#2E2E2E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 13,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#B0D1C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118 31C118 40.9411 109.941 49 100 49C90.0589 49 82 40.9411 82 31C82 21.0589 90.0589 13 100 13C109.941 13 118 21.0589 118 31Z",
    fill: "#BEEDD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.739 23.1812C109.174 22.6456 109.962 22.5646 110.497 22.9999C111.033 23.4353 111.115 24.2226 110.68 24.7583L99.0803 39.7881C98.6515 40.3157 97.8796 40.4036 97.3429 39.9862L88.9632 33.4735C88.4187 33.0497 88.3206 32.2651 88.7442 31.7203C89.168 31.1754 89.9533 31.0765 90.4983 31.5002L97.9123 37.2611L108.739 23.1812Z",
    fill: "#234F4A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 37,
    r: 6,
    stroke: "#2E2E2E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingStart);
export default __webpack_public_path__ + "static/media/onboarding-start.221fa899d4f15caeb4d3270576c801f7.svg";
export { ForwardRef as ReactComponent };